import css_text from '/srv/www/htdocs/loc/app/styles/web_components/badge.css';

class YalwaBadge extends HTMLElement {
	
	static get observedAttributes() {
		return ['intent', 'variant', 'size', 'shape', 'outside_border', 'weight'];
	}
	
	constructor() {
		super();
		this.core_element = null;
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
		}
		this.apply_css();
	}
	
	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		const sheet = new CSSStyleSheet();
		sheet.replaceSync(css_text + `
		::slotted(span[slot="icon_left"]),
		::slotted(span[slot="icon_only"]) {
			display: inline-flex;
			width: 20px;
			height: 20px;
		}
		[data-size="s"] {
			::slotted(span) {
			   width: 12px;
			   height: 12px;
			}
		}
		[data-size="l"] {
			::slotted(span) {
			   width: 24px;
			   height: 24px;
			}
		}`); // adding it here because this syntax breaks our ancient sass version
		this.shadowRoot.adoptedStyleSheets = [sheet];
	}
	
	connectedCallback() {
		this.initialize_template();
		this.render();
		jQuery(this).removeClass('invisible');
	}
	
	attributeChangedCallback(name, old_value, new_value) {
		if (old_value !== new_value) {
			this.render();
		}
	}
	
	initialize_template() {
		if (!this.shadowRoot.firstChild) {
			const template = document.createElement('template');
			template.innerHTML = `
                <span class="badge" part="badge">
                    <slot name="icon_left" part="icon_left"></slot>
                    <slot part="label"></slot>
                </span>
            `;
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.core_element = this.shadowRoot.querySelector('.badge');
	}
	
	render() {
		if (!this.core_element) {
			return;
		}
		this.core_element.setAttribute('data-intent', this.getAttribute('intent') || 'primary');
		this.core_element.setAttribute('data-variant', this.getAttribute('variant') || 'fill');
		this.core_element.setAttribute('data-size', this.getAttribute('size') || 'm');
		this.core_element.setAttribute('data-shape', this.getAttribute('shape') || 'rectangle');
		this.core_element.setAttribute('data-weight', this.getAttribute('weight') || 'regular');
		if (this.hasAttribute('outside_border')) {
			this.core_element.setAttribute('data-outside_border', '');
		}
		const label_slot = this.shadowRoot.querySelector('slot:not([name])');
		if (label_slot && jQuery.trim(label_slot?.assignedNodes().map(n => n.textContent || '').join('')).length === 0) {
			this.core_element.setAttribute('data-icon-only', '');
		} else {
			this.core_element.removeAttribute('data-icon-only');
		}
	}
}

customElements.define('yalwa-badge', YalwaBadge);